import React, { FC, memo } from 'react';

interface Props {
  children: React.ReactNode;
  show: boolean;
}

const LazyToggleContent: FC<Props> = ({ children, show = false }) =>
  show ? <>{children}</> : <noscript>{children}</noscript>;

export default memo(LazyToggleContent);
